import { MovieInfoOutput } from "movieapi";
import * as React from "react";
import MovieAutoComplete from "./MovieAutocomplete";

export interface IChooseMovieProps {
  data: MovieInfoOutput;
  handleMovieChange: (movieInfo: MovieInfoOutput) => void;
}

export default class ChooseMovie extends React.Component<
  IChooseMovieProps,
  {}
> {
  constructor(props: IChooseMovieProps) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <div>
        <p>
          You can select a movie which will autofill the fields in the following
          steps or you can enter the fields in the following steps manually.
        </p>
        <p>
          <strong>Warning</strong> This will change data you have inputted
          manually in the following pages.
        </p>
        <MovieAutoComplete
          data={this.props.data}
          handleMovieChange={this.props.handleMovieChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ChooseMovie.tsx